import { render, staticRenderFns } from "./QuickResponseChatHandler.vue?vue&type=template&id=64772ad4&scoped=true&"
import script from "./QuickResponseChatHandler.vue?vue&type=script&lang=js&"
export * from "./QuickResponseChatHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64772ad4",
  null
  
)

export default component.exports